export function validatePassword(pw) {
  if (pw.length < 8) return false;
  if (!/[A-Z]/.test(pw)) return false;
  if (!/[0-9]/.test(pw)) return false;
  if (/\s/.test(pw)) return false;
  return true;
}

export function validateUsername(name) {
  if (name.length < 3) return "username_too_short";
  if (name.length > 20) return "username_too_long";
  if (!/^[a-zA-Z0-9._-]+$/.test(name)) return "username_invalid_chars";
  return null;
}

const LATIN_LOCATION_PATTERN = /^[A-Za-z .'-]+$/;
const LATIN_LOCATION_ERROR_KEY = "country_city_latin_only_error";

function validateLatinLocationField(value, { requiredKey, invalidKey, t, required = true }) {
  const normalizedValue = typeof value === "string" ? value.trim() : "";
  if (!normalizedValue) {
    return required ? t(requiredKey) : null;
  }

  if (!LATIN_LOCATION_PATTERN.test(normalizedValue)) {
    return t(invalidKey, {
      defaultValue: "Please use English/Latin letters only for country and city.",
    });
  }

  return null;
}

export function validateCountry(country, t, options = {}) {
  return validateLatinLocationField(country, {
    requiredKey: "country_required",
    invalidKey: LATIN_LOCATION_ERROR_KEY,
    t,
    ...options,
  });
}

export function validateCity(city, t, options = {}) {
  return validateLatinLocationField(city, {
    requiredKey: "city_required",
    invalidKey: LATIN_LOCATION_ERROR_KEY,
    t,
    ...options,
  });
}

export function validateRequiredConsents({
  acceptTermsPrivacy,
  acceptProfileVisibility,
  consentTexts,
}) {
  if (!acceptTermsPrivacy) {
    return consentTexts.acceptTermsPrivacy.error;
  }

  if (!acceptProfileVisibility) {
    return consentTexts.acceptProfileVisibility.error;
  }

  return null;
}

export function validateStep3({
  country,
  city,
  accountType,
  t,
}) {
  const countryError = validateCountry(country, t);
  if (countryError) return countryError;

  const cityError = validateCity(city, t);
  if (cityError) return cityError;

  if (!accountType) return t("account_type_required");

  if (accountType === "personal") {
    return null;
  }

  if (accountType === "business") {
    return null;
  }

  return null;
}
